<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>
      </div>
      <div class="column is-full" v-if="value">
        <tab1 :tabs="tabs"
              style="margin-bottom:-1px"
              @selectedValue="selectTab"></tab1>
        <div v-if="selectedTab===0">
          <filter-setting-comp key="productFilterSetting"
                               ref="filter_product"
                               :value.sync="value"
                               :inputTypeList="inputTypeList"
                               :targetParamList="prodParamList"
                               @getData="getFilterSetList('product')"
                               target="product"></filter-setting-comp>
        </div>
        <div v-if="selectedTab===1">
          <filter-setting-comp key="partnerFilterSetting"
                               ref="filter_space"
                               :value.sync="value"
                               :inputTypeList="inputTypeList"
                               :targetParamList="spaceParamList"
                               @getData="getFilterSetList('space')"
                               target="space"></filter-setting-comp>
        </div>

        <div v-if="selectedTab===2">
          <recommend-setting-comp ref="recommend_setting" v-if="false"
                                  :value.sync="value"
                                  :inputTypeList="inputTypeList"
                                  :targetParamList="prodParamList"
                                  @getData="getRecommendSetList"></recommend-setting-comp>
        </div>

        <div v-if="selectedTab===3">
          <!-- 정렬 설정 -->
          <ordering-setting :custom_sort_set="value.custom_sort_set"></ordering-setting>
        </div>
      </div>
      <div class="column is-full">
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import LpCheckGroup from "../../module/common/LpCheckGroup";
  import LpCheckGroupBoolean from "../../module/common/LpCheckGroupBoolean";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import LpImgDropDown from "../../module/common/LpImgDropDown";
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import OrderingSetting from "./component/OrderingSetting";
  import Tab1 from "../../module/common/Tab1";
  import FilterSettingComp from "./component/FilterSettingComp";
  import RecommendSettingComp from "./component/RecommendSettingComp";

  export default {
    name: 'FilterSetting',
    components: {
      RecommendSettingComp,
      FilterSettingComp,
      Tab1,
      OrderingSetting,
      draggable,
      LpSortDropDown,
      LpImgDropDown,
      LpAdmDropInput,
      LpCheckGroupBoolean,
      LpCheckGroup,
      AdminBoxItem},
    data () {
      return {
        value: {
          // filter set의 리스트 (폼형태랑 비슷)
          filter_set_list: [],
          // recommend set 리스트 (폼형태랑 비슷)
          recommend_set_list: [],
          custom_filter_set: {
            id: 0,
            name: '',
            target: 'product',
            data: []
          },
          custom_recommend_set: {
            id: 0,
            name: '',
            data: []
          },
          // 정렬 설정
          custom_sort_set: {
            product_set: [

            ],
            partner_set: [

            ],
            post_set: [

            ],
            product_pop_percent: {
              call_count: 0,
              liked_count: 0,
              review_count: 0,
              review_rate: 0,
              shared_count: 0,
            },
            partner_pop_percent: {
              call_count: 0,
              liked_count: 0,
              post_comment: 0,
              post_liked: 0,
              post_score: 0,
              post_shared: 0,
              post_write: 0,
              review_count: 0,
              review_rate: 0,
              shared_count: 0
            },
            post_pop_percent: {
              score: 0,
              liked_count: 0,
              comment_count: 0,
              shared_count: 0
            }
          }
        },
        prodParamList: [],
        spaceParamList: [],
        partnerParamList: [],
        // 인풋 타입 리스트
        inputTypeList: [],
        tabArr: [
          { label: '상품 필터', value: 0},
          { label: '공간상품 필터', value: 1 , package: 'space'},
          /*{ label: '파트너 필터', value: 1},
          { label: '회원 맞춤 추천 필터', value: 2},*/
          { label: '정렬', value: 3},
        ],
        selectedTab: 0
      }
    },
    created() {
      this.getFilterSetList('product');
      this.getInputTypeList();
      this.getProductParamList();
      this.getSpaceParamList();
      //this.getPartnerParamList();
    },
    computed: {
      tabs() {
        return this.tabArr.filter(i => !i.package || 
        (i.package && this.$store.getters.getPackages.map(i => i.name).indexOf(i.package)>-1))
      }
    },
    methods: {
      selectTab(val) {
        this.selectedTab = val;
        if(this.selectedTab===0) {
          this.getFilterSetList('product');
        } else if(this.selectedTab===1) {
          this.getFilterSetList('space');
        } else if(this.selectedTab===2) {
          this.getRecommendSetList();
        } else if(this.selectedTab===3) {
          this.getSortSet();
        }
      },
      saveData(){
        // 필터 저장
        if(this.selectedTab===0 || this.selectedTab===1) {
          for(let x=0; x<this.value.filter_set_list.length; x++){
            if(!this.value.filter_set_list[x].name) {
              this.toast(`${this.selectedTab===0?'상품':'파트너'} 필터명을 입력하세요`);
              return;
            }
          }
          for(let j=0; j<this.value.custom_filter_set.data.length; j++) {
            let data = this.value.custom_filter_set.data[j];
            if(!data.label) {
              this.toast('추가 필터명을 입력하세요.');
              return;
            }
            if(!data.type) {
              this.toast('필터 스타일을 선택하세요.');
              return;
            }
            if(!data.param_name) {
              this.toast(`매칭시킬 ${this.selectedTab===0?'상품':'파트너'}DB 항목을 선택하세요.`);
              return;
            }
          }
          // 추천 저장하기
          if ( this.value.custom_filter_set.id > 0 ) {
            this.saveFilterSet(this.value.custom_filter_set.id);
          } else {
            this.saveFilterSet();
          }
        } else if(this.selectedTab===2) {
          for(let y=0; y<this.value.recommend_set_list.length; y++){
            if(!this.value.recommend_set_list[y].name) {
              this.toast('회원 추천 필터를 입력하세요');
              return;
            }
          }
          for(let i=0; i<this.value.custom_recommend_set.data.length; i++) {
            let data = this.value.custom_recommend_set.data[i];
            if(!data.param_name) {
              this.toast('매칭시킬 상품 DB 항목을 선택하세요.');
              return;
            }
            if(!data.user.param_name) {
              this.toast('맞춤 추천에 이용할 회원 DB 항목을 선택하세요.');
              return;
            }
          }
          // 추천 저장하기
          if ( this.value.custom_recommend_set.id > 0 ) {
            this.saveRecommendSet(this.value.custom_recommend_set.id);
          }
          else {
            this.saveRecommendSet();
          }

        } else if(this.selectedTab===3) {
          // 정렬 저장하기
          this.saveSortSet();
        }
      },
      // 상품 필터 리스트(id, name) 가져오기
      getFilterSetList(target){
        this.$axios.get(this.getUrl(`service/set/filter?target=${target}`)).then(res=>{
          if(res.status===200) {
            this.value.filter_set_list = res.data;
            this.value.custom_filter_set.target = target;
            this.$refs[`filter_${target}`].init();
          }
        })
      },
      // 추천 가져오기
      getRecommendSetList() {
        this.$axios.get(this.getUrl('service/set/recommend')).then(res=>{
          if (res.status===200) {
            this.value.recommend_set_list = res.data;
            this.$refs.recommend_setting.init();
            /*else {
              if (this.value.custom_recommend_set.data.length === 0) {
                this.value.custom_recommend_set.data = this.recommendSetData();
              }
            }*/
          }
        })
      },
      // 정렬 설정 값 가져오기
      getSortSet(){
        this.$axios.get(this.getUrl('service/set/sort')).then(res=>{
          if(res.status===200) {
            ['product', 'partner'].forEach(key=>{
              res.data[`${key}_set`] = res.data[`${key}_set`].filter(i=> {
                return i.value !== '-calls';
              });
              if(res.data[`${key}_set`].findIndex(i=>{ return i.value === '-order' })===-1)   {
                res.data[`${key}_set`].push({
                  is_active: false,
                  is_conversion: true,
                  label: '판매량 높은 순',
                  value: '-order'
                })
              }
              // 파트너 정렬 값에서 가격 관련 정렬 값 제거
              if (key === 'partner') {
                res.data[`${key}_set`] = res.data[`${key}_set`].filter(item => item.value.indexOf('price') === -1)
              }
            });
            
            this.value.custom_sort_set = res.data;
            // let result = [];
            // // 파트너 가격 관련 정렬 제외
            // this.value.custom_sort_set.forEach(item => {
            //   if (['-price__price', 'price__price'].indexOf(item.value)===-1) {
            //     result.push(item);
            //   }
            // })
            // this.value.custom_sort_set = result;
            this.showPopCheck();
          }
        });
      },
      isPopActive(set_list){
        if (set_list) {
          for(let i=0; i<set_list.length; i++) {
            if(set_list[i].value === '-pop_score' && set_list[i].is_active === true){
              return true;
            }
          }
        }
        else return false;
      },
      // 최초 로딩시 인기순 체크박스 체크되었는지 확인
      showPopCheck() {
        let product_set = this.value.custom_sort_set.product_set;
        //console.log(product_set)
        if(this.isPopActive(product_set) === true){
          this.showProductPop = true;
        }

        let partner_set = this.value.custom_sort_set.partner_set;
        if(this.isPopActive(partner_set) === true){
          this.showPartnerPop = true;
        }

        let post_set = this.value.custom_sort_set.post_set;
        if(this.isPopActive(post_set) === true){
          this.showPostPop = true;
        }
      },
      // 인풋 타입들
      getInputTypeList() {
        this.$axios.get(this.getUrl('service/set/input')).then(res=>{
          if(res.status===200) {
            this.inputTypeList = res.data;
          }
        })
      },
      // 상품 맞춤 DB 목록
      getProductParamList() {
        this.$axios.get(this.getUrl('service/set/productdb/list')).then(res=>{
          if(res.status===200) {
            this.prodParamList = res.data;
          }
        })
      },
      // 공간 상품 맞춤 DB 목록
      getSpaceParamList() {
        this.$axios.get(this.getUrl('service/set/space_productdb/list')).then(res=>{
          if(res.status===200) {
            this.spaceParamList = res.data;
          }
        })
      },
      // 파트너 맞춤 DB 목록
      getPartnerParamList() {
        this.$axios.get(this.getUrl('service/set/partnerdb/list')).then(res=>{
          if(res.status===200) {
            this.partnerParamList = res.data;
          }
        })
      },
      // 상품 필터 저장하기
      saveFilterSet(id) {
        if(id) {
          this.$axios.patch(this.getUrl('service/set/filter/' + this.value.custom_filter_set.id),
            this.value.custom_filter_set).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.')
              this.getFilterSetList(this.value.custom_filter_set.target);
            }
          }).catch(error=> {
            if(error.response) {
              this.toast('필터저장시 서버에 에러가 발생하였습니다. 관리자에게 문의주세요.');
            }
          })
        } else {
          this.$axios.post(this.getUrl('service/set/filter'), this.value.custom_filter_set).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.')
              this.getFilterSetList(this.value.custom_filter_set.target);
            }
          }).catch(error=>{
            if(error.response) {
              this.toast('필터저장시 서버에 에러가 발생하였습니다. 관리자에게 문의주세요.');
            }
          })
        }

      },
      // 추천 저장하기
      saveRecommendSet(id) {
        // 수정
        if (id) {
          this.$axios.patch(this.getUrl('service/set/recommend/' + this.value.custom_recommend_set.id),
            this.value.custom_recommend_set).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.getRecommendSetList();
            }
          }).catch(error=> {
            if(error.response) {
              this.toast('추천 저장시 서버에 에러가 발생하였습니다. 관리자에게 문의주세요.');
            }
          })
        }
        // 등록
        else {
          this.$axios.post(this.getUrl('service/set/recommend'), this.value.custom_recommend_set).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.getRecommendSetList();
            }
          }).catch(error=> {
            if(error.response) {
              this.toast('추천 저장시 서버에 에러가 발생하였습니다. 관리자에게 문의주세요.');
            }
          })
        }
      },
      // 정렬 저장하기
      saveSortSet() {
        this.$axios.patch(this.getUrl('service/set/sort'), this.value.custom_sort_set).then(res=>{
          if(res.status===200) {
            this.toast('저장되었습니다.');
            // this.getSortSet();
          }
        }).catch(error=> {
          this.toast('정렬저장시 서버에 에러가 발생하였습니다. 관리자에게 문의주세요.');
        })
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-form-type
    border 1px solid #7a7a7a
    border-radius 3px
    cursor pointer
    margin-right 8px
    margin-bottom 2px
    position relative


  .selected
    color $primary
    border 1px solid $primary
    background-color unset

  .lp-form-add
    width 60px
    border 1px solid
    border-radius 3px
    padding 6px 8px
    text-align center
    margin-right 8px
    cursor pointer
    height 33.5px

  .lp-form-type-input
    border 0
    box-shadow unset
    cursor pointer

  .add-filter
    padding 12px 24px
    color $primary
    cursor pointer

  .lp-form-close
    position absolute
    right 2px
    top 5px
    font-size 1.5rem

  /*.styled-select select {
    line-height: 1;
    border: 0;
    border-radius: 5px;
    height: 34px;
    background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right #ddd;
    -webkit-appearance: none;
    background-position-x: 244px;
  }*/

</style>
